/**
 * Returns a function that will only be called once every n milliseconds
 *
 * @param fn
 * @param delay
 * @return {function(...[*])}
 */
// biome-ignore lint/suspicious/noExplicitAny: Generic debounce function
export const debounce = <T extends (...args: any[]) => any>(fn: T, delay: number) => {
    if (typeof fn !== 'function') {
        throw new Error('Debounce requires a callback function');
    }

    if (!delay || Number.isNaN(delay)) {
        throw new Error('Debounce requires a delay');
    }

    let timeout: ReturnType<typeof setTimeout> | null = null;

    return (...args: Parameters<T>) => {
        const later = () => {
            timeout = null;
            return fn(...args);
        };

        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(later, delay);
    };
};
